import { toMoment, getSeeComponentsValue } from 'api/helpers';
import { sortArray } from 'utils/helpers';
import OrderType from './OrderType';
import he from 'he';

export default class SearchItem {
	static getItemName = item => (item.Number ? item.Number : item.Name);

	number = '';
	start_date = null;
	quantity = null;
	list_price = null;
	promo_price = null;
	ta = null;
	net_price = null;
	est_ship_date = null;
	est_ship_date_for_cart = null;
	invoice_hold_weeks = null;
	displayed_invoice_hold_weeks = '';
	order_type = null;
	is_drop_ship = false;
	promotion_id = 0;
	category_id = 0;
	id = 0;
	image_url = null;
	pack_id = 0;
	is_pack = false;
	is_configurable = false;
	is_preview = false;
	currency_symbol = '';
	country_short_name = '';
	promotion_name = '';
	end_date = null;
	offerings = null;
	category_end_date = '';
	category_name = '';
	name = '';
	db_item_name = '';
	base_number = '';
	promotion_end_date = '';
	total_config_qty_ordered = 0;
	category_promotion_class_id = 0;
	quantity_available = 0;
	promo_no_of_days = null;
	pack_name = null;
	price_list = null;
	item_description = '';
	category_ship_type_id = 0;
	category_ship_type_name = '';

	constructor(item) {
		this.start_date = toMoment(item.StartDate);
		this.quantity = item.Quantity;
		this.list_price = item.ListPrice;
		this.promo_price = item.PromoPrice;
		this.ta = item.TA;
		this.name = he.decode(item.Name);
		this.db_item_name = item.Name;
		this.number = item.Number;
		this.itemName = SearchItem.getItemName(item);
		this.net_price = item.NetPrice;
		this.est_ship_date = item.IsPack ? '' : toMoment(item.EstShipDate);
		this.est_ship_date_for_cart = toMoment(item.EstShipDateForCart);
		this.invoice_hold_weeks = item.OrderType.HoldInvoiceWeeks;
		this.displayed_invoice_hold_weeks = getSeeComponentsValue(
			item.OrderType.HoldInvoiceWeeks.toString(),
			item.IsPack
		);
		this.order_type = new OrderType(item.OrderType);
		this.is_drop_ship = item.IsDropShipAllowed;
		this.promotion_id = item.PromotionId;
		this.category_id = item.CategoryId;
		this.id = item.Id;
		this.image_url = item.ImageUrl;
		this.pack_id = item.PackId;
		this.is_pack = item.IsPack;
		this.is_configurable = item.IsConfigurable;
		this.is_preview = item.IsPreview;
		this.promotion_name = item.PromotionName;
		this.end_date = toMoment(item.EndDate);
		this.currency = {
			currency_symbol: item.CurrencySymbol,
			country_short_name: item.CountryShortName,
		};
		this.offerings =
			this.is_pack &&
			sortArray(item.Offerings, 'Name').map(item => ({
				id: item.Id,
				promo_no_of_days: item.PromoNoOfDays,
				price_list: item.PriceList,
				price: item.Price,
				image_url: item.ImageUrl,
				name: he.decode(item.Name),
				db_item_name: item.Name,
				number: item.Number,
				quantity: item.Quantity,
				base_number: item.BaseNumber,
				is_configurable: item.IsConfigurable,
				invoice_hold_weeks: item.OrderType.HoldInvoiceWeeks,
				order_type: new OrderType(item.OrderType),
				item_description: item.ItemDescription,
				net_price: item.NetPrice,
				est_ship_date: toMoment(item.EstShipDate),
				promo_price: item.PromoPrice,
				is_drop_ship_allowed: item.IsDropShipAllowed,
			}));
		this.category_end_date = toMoment(item.CategoryEndDate);
		this.category_name = item.CategoryName;
		this.base_number = item.BaseNumber;
		this.promotion_end_date = toMoment(item.PromotionEndDate);
		this.total_config_qty_ordered = item.TotalConfigQtyOrdered;
		this.category_promotion_class_id = item.CategoryPromotionClassId;
		this.quantity_available = item.QuantityAvailable;
		this.promo_no_of_days = item.PromoNoOfDays;
		this.pack_name = item.IsPack ? item.PackName : null;
		this.price_list = item.PriceList;
		this.item_description = item.ItemDescription;
		this.category_ship_type_id = item.CategoryShipTypeId;
		this.category_ship_type_name = item.CategoryShipTypeName;
	}
}



// WEBPACK FOOTER //
// ./src/api/models/SearchItem.js